module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogIDxwYXRoIGQ9Ik0xMC45NCAyMS4wNmExLjUgMS41IDAgMCAwIDIuMTIgMGw5LjU0Ny05LjU0NWExLjUgMS41IDAgMSAwLTIuMTIyLTIuMTIyTDEyIDE3Ljg4IDMuNTE1IDkuMzkzYTEuNSAxLjUgMCAwIDAtMi4xMjIgMi4xMjJsOS41NDYgOS41NDZ6TTEwLjUgMHYyMGgzVjBoLTN6IiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.svg
// module id = l4LJ
// module chunks = 1